import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, Facebook, Twitter, Shield, Truck, Undo2 } from "lucide-react";
import { VoltixLogo } from "./VoltixLogo";

export default function Footer() {
  return (
    <footer className="mt-32 border-t border-border bg-secondary/40" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2 space-y-5">
            <VoltixLogo />
            <p className="text-sm text-muted-foreground max-w-xs">Tecnologia ao teu alcance. Smartphones, computadores, áudio e gaming com entrega em Portugal e Angola.</p>
            <a href="tel:+351929163121" className="flex items-center gap-2 text-sm hover:text-primary transition-colors" data-testid="footer-phone">
              <Phone className="w-4 h-4" /> +351 929 163 121
            </a>
            <a href="mailto:support@voltix.com" className="flex items-center gap-2 text-sm hover:text-primary transition-colors">
              <Mail className="w-4 h-4" /> support@voltix.com
            </a>
            <div className="flex items-center gap-3 pt-2">
              <a href="#" className="p-2 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-colors" data-testid="social-instagram"><Instagram className="w-4 h-4" /></a>
              <a href="#" className="p-2 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-colors" data-testid="social-facebook"><Facebook className="w-4 h-4" /></a>
              <a href="#" className="p-2 rounded-full bg-muted hover:bg-primary hover:text-primary-foreground transition-colors" data-testid="social-twitter"><Twitter className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold mb-4">Loja</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/produtos" className="hover:text-primary transition-colors">Todos os produtos</Link></li>
              <li><Link to="/categorias" className="hover:text-primary transition-colors">Categorias</Link></li>
              <li><Link to="/novidades" className="hover:text-primary transition-colors">Novidades</Link></li>
              <li><Link to="/promocoes" className="hover:text-primary transition-colors">Promoções</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold mb-4">Ajuda</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/politicas/envio" className="hover:text-primary transition-colors">Envio</Link></li>
              <li><Link to="/politicas/devolucao" className="hover:text-primary transition-colors">Devoluções</Link></li>
              <li><Link to="/politicas/privacidade" className="hover:text-primary transition-colors">Privacidade</Link></li>
              <li><Link to="/politicas/termos" className="hover:text-primary transition-colors">Termos</Link></li>
              <li><Link to="/contacto" className="hover:text-primary transition-colors">Contacto</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold mb-4">Pagamentos</h4>
            <div className="flex flex-wrap gap-2 text-xs">
              {["Visa", "Mastercard", "AmEx", "PayPal", "Apple Pay", "G Pay"].map((p) => (
                <span key={p} className="px-2.5 py-1.5 rounded-md border border-border bg-background font-mono">{p}</span>
              ))}
            </div>
            <div className="mt-6 grid grid-cols-3 gap-2 text-[10px] text-muted-foreground">
              <div className="flex flex-col items-center gap-1"><Shield className="w-4 h-4" /> PCI-DSS</div>
              <div className="flex flex-col items-center gap-1"><Truck className="w-4 h-4" /> PT · AO</div>
              <div className="flex flex-col items-center gap-1"><Undo2 className="w-4 h-4" /> 30 dias</div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} VOLTIX. Todos os direitos reservados.</p>
          <p>Tecnologia ao teu alcance.</p>
        </div>
      </div>

      {/* Floating WhatsApp */}
      <a
        href="https://wa.me/351929163121"
        target="_blank" rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-40 bg-[#25D366] text-white rounded-full p-4 shadow-xl hover:scale-110 transition-transform"
        data-testid="whatsapp-float"
        aria-label="Contactar via WhatsApp"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
      </a>
    </footer>
  );
}
